module.exports = __webpack_public_path__ + "static/media/themify.e23a7dca.ttf";